import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";

import { FetchController } from "./fetch-controller";

/*
 * A "simple" fetch that stores the object on internal state,
 * rather than having to wire up redux state.
 */
class SimpleFetchController extends React.PureComponent {

  static get propTypes() {
    const fetchProps = FetchController.propTypes;
    delete fetchProps.objectLoaded;

    return {
      ...fetchProps,
      errorChild: PropTypes.element,
    };
  }

  constructor(props) {
    super(props);

    this._isMounted = false;

    this.state = {
      hasError: false,
      object: null,
      objectLoaded: false,
    };

    this.beginFetch = this.beginFetch.bind(this);
    this.fetchWrapper = this.fetchWrapper.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async beginFetch(objId) {
    await new Promise((resolve) => {
      if (this._isMounted) {
        this.setState(
          {
            hasError: false,
            object: null,
            objectLoaded: false,
          },
          resolve
        );
      } else {
        resolve();
      }
    });

    return this.fetchWrapper(objId);
  }

  fetchWrapper(objId) {
    const { fetchObject } = this.props;

    return fetchObject(objId)
      .then((resp) => {
        if (!this._isMounted) return;
        this.setState({
          hasError: false,
          object: get(resp, "data.data"),
          objectLoaded: true,
        });
      })
      .catch(() => {
        if (!this._isMounted) return;
        this.setState({
          hasError: true,
          object: null,
          objectLoaded: false,
        });
      });
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { children, errorChild, fetchObject, ...props } = this.props;
    const { object, objectLoaded, hasError } = this.state;

    if (hasError) {
      return errorChild || <div>Error fetching object.</div>;
    }

    return (
      <FetchController
        {...props}
        fetchObject={this.beginFetch}
        object={object}
        objectLoaded={objectLoaded}
      >
        {children}
      </FetchController>
    );
  }
}

export { SimpleFetchController };
